export default {
  module: {
    list: "/module",
    create: "/module",
    update: "/module",
    getById: (id) => `/module/${id}`,
    filterByCategory: (id) => `/module/filter/${id}`,
  },
  task: {
    create: "/task",
    update: "/task",
    getByModuleId: (id) => `/task/${id}`,
  },
  category: {
    list: "/category",
    create: "/category",
  },
  workSheet: {
    getByUserId: (id) => `/worksheet/enrolled/${id}`,
    getById: (id) => `/worksheet/${id}`,
    getByIdByAdmin: (id,userId) => `/worksheet/${id}/${userId}`,
    assign: "/user-module",
    bulkAssign: "/worksheet/bulk-assign",
    getWorkSheetByUserId: (id) => `/user-module/${id}`,
    updateTask: "/worksheet",
    progress: (id) => `/worksheet/progress/${id}`,
    heatmap: (id) => `/worksheet/map/${id}`,
    graph: (id) => `/worksheet/graph/${id}`,
    create: "/user-module/worksheet",
    enroll: "/worksheet",
    config: (trainingId, userId) => `/worksheet/config/${trainingId}/user/${userId}`,
    getWorkSheet: `/worksheet/search/training-data`,
    usersForEnrolledTraining: (id) => `/worksheet/search/training-data/${id}`,
    setScore: "/score",
    getScore: (worksheetId) => `/score/${worksheetId}`,
    getallScore: (trainingId) => `/score/get-all/${trainingId}`,
    getProgress: (trainingId) => `/progress/${trainingId}`,
    trainingScore: "/worksheet/training-score",
    trainingStatus: "/worksheet/training-status",
    taskScore:(adminId) => `/worksheet/user-score/${adminId}`
  },
  comment: {
    create: "/comment",
    getByWorkSheetId: (id) => `/comment/${id}`,
  },
  users: {
    login: "/users/login",
    create: "/users",
    list: "/users",
    assignee: "/users/repotees",
    getHistory: (id) => `/history/${id}`,
    getAllHistory: "/history",
    locationOption: "/reference/location",
    teamOption: "/reference/team",
    designation: "/reference/designation",
    manager: "/users/search",
    getEmployeeByManagerId: (id) => `/users/get-subordinates/${id}`,
    updatePassword:"/users/update-pwd"
  },
  training: {
    list: "/training/listings",
    create: "/training",
    getById: (id) => `/training/${id}`,
    listByPagination: "/training/category",
    listOptions: "/training",
    listOnlyTraining: "/training/search",
    createdList: (id) => `/training/user/${id}/config`,
  },
  template: {
    create: "/template",
    getTemplate: "/template/all/templates",
    setData: (adminId) => `/template/add-score/${adminId}`,
    evaluationReport:(adminId) =>`/template/score-card/${adminId}`
  }
};
